import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import * as i2 from 'primeng/radiobutton';
import * as i3 from '@angular/forms';
import * as i4 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class ImportProfileDetailsService {
    constructor() { }
}
ImportProfileDetailsService.ɵfac = function ImportProfileDetailsService_Factory(t) { return new (t || ImportProfileDetailsService)(); };
ImportProfileDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: ImportProfileDetailsService, factory: ImportProfileDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportProfileDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ImportProfileDetailsComponent {
    constructor(dynamicDialogRef, dialogService, dynamicDialogConfig) {
        this.dynamicDialogRef = dynamicDialogRef;
        this.dialogService = dialogService;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.title = this.dynamicDialogConfig.header;
        if (this.dynamicDialogConfig.data && this.dynamicDialogConfig.data.deleteMessage) {
            this.deleteConfirmationMessage = this.dynamicDialogConfig.data.deleteMessage;
        }
        else {
            this.deleteConfirmationMessage = 'Do you want to merge or reset the data from individual profile?';
        }
    }
    ngOnInit() {
    }
    handleYes() {
        // this.dynamicDialogRef.close(true);
        this.dynamicDialogRef.close({ data: this.selectData });
    }
    handleNo() {
        this.dynamicDialogRef.close(false);
    }
}
ImportProfileDetailsComponent.ɵfac = function ImportProfileDetailsComponent_Factory(t) { return new (t || ImportProfileDetailsComponent)(i0.ɵɵdirectiveInject(i1.DynamicDialogRef), i0.ɵɵdirectiveInject(i1.DialogService), i0.ɵɵdirectiveInject(i1.DynamicDialogConfig)); };
ImportProfileDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ImportProfileDetailsComponent, selectors: [["import-profile-details"]], features: [i0.ɵɵProvidersFeature([DialogService])], decls: 18, vars: 4, consts: [[1, "col-md-12", "p-0", "row", "delete-header"], [1, "col-md-10", "p-0"], [1, "pi", "pi-exclamation-triangle", "pr-2"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "row", "col-md-12", "p-0", "pb-4", "detele-body"], [1, "col-12"], ["name", "data", "label", "Merge", "value", "merge", 1, "mr-2", 3, "ngModel", "ngModelChange"], ["name", "data", "label", "Reset", "value", "reset", 3, "ngModel", "ngModelChange"], [1, "row", "col-md-12", "delete-buttons", "justify-content-end", "d-flex", "pr-0"], [1, "col-md-5", "text-right"], ["pButton", "", "type", "button", "label", "I will do it later", 1, "p-button-outlined", "pull-right", 3, "click"], [1, "col-md-3"], ["pButton", "", "type", "button", "label", "Submit", 1, "mr-3", 3, "click"]], template: function ImportProfileDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span");
        i0.ɵɵelement(3, "i", 2);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "i", 4);
        i0.ɵɵlistener("click", function ImportProfileDetailsComponent_Template_i_click_6_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 5);
        i0.ɵɵelementStart(8, "p");
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵelementStart(11, "p-radioButton", 7);
        i0.ɵɵlistener("ngModelChange", function ImportProfileDetailsComponent_Template_p_radioButton_ngModelChange_11_listener($event) { return ctx.selectData = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "p-radioButton", 8);
        i0.ɵɵlistener("ngModelChange", function ImportProfileDetailsComponent_Template_p_radioButton_ngModelChange_12_listener($event) { return ctx.selectData = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 9);
        i0.ɵɵelementStart(14, "div", 10);
        i0.ɵɵelementStart(15, "button", 11);
        i0.ɵɵlistener("click", function ImportProfileDetailsComponent_Template_button_click_15_listener() { return ctx.handleNo(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 12);
        i0.ɵɵelementStart(17, "button", 13);
        i0.ɵɵlistener("click", function ImportProfileDetailsComponent_Template_button_click_17_listener() { return ctx.handleYes(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("Import ", ctx.title, " Data");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.deleteConfirmationMessage);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.selectData);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngModel", ctx.selectData);
    } }, directives: [i2.RadioButton, i3.NgControlStatus, i3.NgModel, i4.ButtonDirective], styles: [".close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:10px;border-radius:20px;cursor:pointer;font-size:14px}.delete-header[_ngcontent-%COMP%]{color:#01a0da;border-bottom:1px dashed #707070;font-size:22px;font-weight:600;text-align:left;padding:35px 0 10px!important}.delete-header[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#3d3d63;font-size:18px;font-family:Source Sans Pro bold}.detele-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:20px 0;margin-bottom:0;font-size:15px}.delete-buttons[_ngcontent-%COMP%]{border-top:1px dashed #707070;padding:20px 0 0!important;text-align:right}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportProfileDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'import-profile-details',
                templateUrl: 'import-profile-details.component.html',
                styleUrls: ['import-profile-details.component.scss'],
                providers: [DialogService]
            }]
    }], function () { return [{ type: i1.DynamicDialogRef }, { type: i1.DialogService }, { type: i1.DynamicDialogConfig }]; }, null); })();

class ImportProfileDetailsModule {
}
ImportProfileDetailsModule.ɵfac = function ImportProfileDetailsModule_Factory(t) { return new (t || ImportProfileDetailsModule)(); };
ImportProfileDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: ImportProfileDetailsModule });
ImportProfileDetailsModule.ɵinj = i0.ɵɵdefineInjector({ providers: [], imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ImportProfileDetailsModule, { declarations: [ImportProfileDetailsComponent], imports: [PrimengLibraryModule], exports: [ImportProfileDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImportProfileDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [ImportProfileDetailsComponent],
                imports: [
                    PrimengLibraryModule
                ],
                providers: [],
                exports: [ImportProfileDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of import-profile-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ImportProfileDetailsComponent, ImportProfileDetailsModule, ImportProfileDetailsService };
//# sourceMappingURL=import-profile-details.js.map
